var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscirption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-9_1_",
    d: "M14.3206 1H4.78134C2.46097 1 1 2.63285 1 4.95322V11.2268C1 13.5472 2.46097 15.18 4.78134 15.18H14.4066C16.7269 15.18 18.1879 13.5472 18.1879 11.2268V4.95322C18.1879 2.63285 16.7269 1 14.3206 1Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 5.297H18.1879",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.26562 11.3987H7.53133",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.26562 8.73458H6.67193",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.6875 11.5706H13.8907C14.4063 11.5706 14.836 11.1409 14.836 10.6252V9.4221C14.836 8.90646 14.4063 8.47676 13.8907 8.47676H12.6875C12.1719 8.47676 11.7422 8.90646 11.7422 9.4221V10.6252C11.7422 11.1409 12.1719 11.5706 12.6875 11.5706Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscirption);
export default __webpack_public_path__ + "static/media/subscirption.1a092c496d02bd75a19e88e6abe0be3d.svg";
export { ForwardRef as ReactComponent };